import { AbstractBlock } from '../AbstractBlock';
// import route from 'riot-route/lib/tag';
// import { saveBlock } from '../saveBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';
import { blocklyStore } from '../blocklyStore';

export class LinkSelectButton extends AbstractBlock {
  constructor(title: string) {
    super('link-select-button', '');
    this.title = title;
    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_link_select_button', () => {
        // saveBlock((e) => {
        //   route('/link_select/' + blocklyStore.project_id);
        // });
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml(): HTMLElement {
    const el = document.createElement('button');
    el.setAttribute('text', this.title);
    el.setAttribute('callbackKey', 'click_link_select_button');
    el.setAttribute('web-class', 'link_select_button');
    return el;
  }
}
